module.exports = __webpack_public_path__ + "static/media/hearclearpro-earwax-guard-4.fe84b045.png";